import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-change-password-page',
  imports: [ChangePasswordComponent],
  templateUrl: `./change-password-page.component.html`,
  styleUrl: './change-password-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordPageComponent {}
